import { FC, useEffect, useRef } from 'react';

import styles from './Header.module.css';
import mantisLogo from '../../assets/images/marketing/TSPS_largest_mantis.png';
import { animations, attachAnimations, interactiveStyle } from '../../utils/interactions';
import Icon from '../Icon/Icon';

const Header: FC = () => {
  const logoRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLHeadingElement>(null);
  const taglineRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const cleanup = attachAnimations([
      {
        element: logoRef.current,
        animation: animations.gentleBounce(logoRef.current!),
        triggers: ['hover', 'touch'],
      },
      {
        element: titleRef.current,
        animation: animations.gentleBounce(titleRef.current!),
        triggers: ['click', 'touch'],
      },
      {
        element: taglineRef.current,
        animation: animations.rock(taglineRef.current?.querySelectorAll('.taglineIcon') || []),
        triggers: ['hover', 'touch'],
      },
    ]);

    return cleanup;
  }, []);

  return (
    <header className={styles.header} role="banner">
      <div className={styles.content}>
        <div className={styles.logoContainer}>
          <div ref={logoRef} className={styles.logoWrapper} style={interactiveStyle}>
            <img
              src={mantisLogo}
              alt="Tire Swing Pest Solutions Mantis Logo"
              className={styles.logo}
            />
          </div>
          <h1 ref={titleRef} className={styles.title} style={interactiveStyle}>
            Tire Swing Pest Solutions
          </h1>
          <p className={styles.subtitle}>Your Trusted Pest Control Partner in Gardendale, AL</p>
          <div className={styles.contactInfo}>
            <p ref={taglineRef} className={styles.tagline} style={interactiveStyle}>
              <Icon
                icon="mdi:phone"
                className={`${styles.taglineIcon} taglineIcon`}
                size="md"
                aria-hidden={true}
                aria-label="Phone Icon"
              />{' '}
              205.382.8050
            </p>
            <p className={styles.tagline} style={interactiveStyle}>
              <Icon
                icon="mdi:email"
                className={`${styles.taglineIcon} taglineIcon`}
                size="md"
                aria-hidden={true}
                aria-label="Email Icon"
              />{' '}
              info@tireswingpestsolutions.com
            </p>
            <p className={styles.address}>208 Laurel Dr, Gardendale, AL 35071</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
